export default __webpack_public_path__ + "static/media/turn_arrow.e0d118cb.svg";